import { Enumeration } from '@bp/shared/models/core/enum';

export class ArticleStatus extends Enumeration {

	static published = new ArticleStatus();

	static notPublished = new ArticleStatus();

}
